import defaultState from './default';
import active from './active';
import disabled from './disabled';

export default {
  default: defaultState,
  active,
  disabled,
};
